export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/f59daa17-e987-4eec-86cb-eef4b53824fd.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/29de86fa-a0cb-409e-b907-ebaf92af787e.png',
};
